module.exports = __webpack_public_path__ + "static/diy_recipe_bath_bombs_thumbnail-7414d133045d23e6d549e8348b8fc30d.jpg";